/* Provador virtual Ankor — interface (manequim 360° + 3 etapas).
 * Uso: AnkorProvador.iniciar({ base, produto: { handle, titulo, foto, tipo, tamanhos, tabela, modelagem }, aoEscolher(tamanho) })
 * "tabela" é a entrada do produto em size-charts-full.json (mesmo formato do tema).
 */
(function () {
  "use strict";
  const M = window.ProvadorMotor;
  const CHAVE = "ankor-provador-v1";
  const COR = { "-2": "#b8492f", "-1": "#d9894a", "0": "#2f7d57", "1": "#6d93bf", "2": "#2f5d93" };
  // cor do mapa no manequim: tom da legenda clareado, aplicado por multiplicação (o volume da porcelana aparece)
  const RGB = Object.fromEntries(Object.entries(COR).map(([k, h]) => [k, [1, 3, 5].map((i) => Math.round(parseInt(h.slice(i, i + 2), 16) * 0.72 + 255 * 0.28))]));
  // sem pintar o corpo: o caimento aparece só nas etiquetas com setinha
  const SEM_MAPA = true;
  const NOME_CURTO = { ombro: "Ombro", peito: "Peito", cintura: "Cintura", comprimento: "Comprimento", manga: "Manga" };
  const IDX_REGIAO = { 2: "ombro", 3: "peito", 4: "cintura", 5: "comprimento", 6: "manga" };
  const NUM = { estreito: 2, medio: 3, largo: 4, chapada: 2, normal: 3, saliente: 4, justo: 2, regular: 3, solto: 4 };
  const num = (v) => (v == null ? 3 : NUM[v] || +v || 3);
  const svg = (d, w = 1.7) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${w}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
  const ICONE = {
    fechar: svg('<path d="M6 6l12 12M18 6L6 18"/>'),
    esq: svg('<path d="M15 6l-6 6 6 6"/>', 2),
    dir: svg('<path d="M9 6l6 6-6 6"/>', 2),
    voltar: svg('<path d="M19 12H5M11 6l-6 6 6 6"/>'),
    refazer: svg('<path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v4.5h4.5"/>'),
    lupa: svg('<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4 4M11 8.5v5M8.5 11h5"/>'),
    menos: svg('<path d="M6 12h12"/>', 2),
    mais: svg('<path d="M12 6v12M6 12h12"/>', 2),
    peito: svg('<path d="M5 7c2 1.5 4.5 2 7 2s5-.5 7-2M5 7v4c0 4 3 7 7 7s7-3 7-7V7"/>'),
    cintura: svg('<path d="M6 5c1.5 3 1.5 11 0 14M18 5c-1.5 3-1.5 11 0 14M8 12h8"/>'),
    sacola: svg('<path d="M6 8h12l-1 12H7L6 8zM9 8V7a3 3 0 0 1 6 0v1"/>'),
    cabide: svg('<path d="M12 7.5a2 2 0 1 1 2-2c0 1.2-2 1.6-2 3.2v.8L3 15.5c-.9.6-.5 2 .6 2h16.8c1.1 0 1.5-1.4.6-2L12 9.5"/>', 1.6),
  };
  const ler = () => { try { return JSON.parse(localStorage.getItem(CHAVE)) || null; } catch (e) { return null; } };
  const gravar = (p) => { try { localStorage.setItem(CHAVE, JSON.stringify(p)); } catch (e) { /* sem armazenamento */ } };
  const apagar = () => { try { localStorage.removeItem(CHAVE); } catch (e) { /* idem */ } };
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const el = (tag, attrs, html) => {
    const n = document.createElement(tag);
    for (const k in attrs || {}) {
      if (k === "class") n.className = attrs[k];
      else if (k.startsWith("on")) n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    }
    if (html != null) n.innerHTML = html;
    return n;
  };
  const carregarImg = (src) => new Promise((ok, erro) => { const i = new Image(); i.decoding = "async"; i.onload = () => ok(i); i.onerror = erro; i.src = src; });
  const cacheJson = {};
  const json = (url) => (cacheJson[url] = cacheJson[url] || fetch(url).then((r) => { if (!r.ok) throw new Error(url); return r.json(); }));

  /* ---------- manequim giratório com mapa de caimento ---------- */
  const sprites = {};
  class Manequim {
    constructor(canvas, cfg, base, aoGirar) {
      this.cv = canvas; this.cfg = cfg; this.url = base; this.aoGirar = aoGirar;
      [this.w, this.h] = cfg.quadro;
      // canvas mais largo que o boneco: as etiquetas ficam nas laterais, fora do corpo
      this.W = Math.round(this.w * 1.7); this.ox = Math.round((this.W - this.w) / 2);
      this.cv.width = this.W; this.cv.height = this.h;
      if (window.ResizeObserver) new ResizeObserver(() => this.desenhar()).observe(this.cv);
      this.ctx = this.cv.getContext("2d");
      this.of1 = document.createElement("canvas"); this.of1.width = this.w; this.of1.height = this.h;
      this.of2 = document.createElement("canvas"); this.of2.width = this.w; this.of2.height = this.h;
      this.quadro = 0; this.niveis = {}; this.perto = false;
      this._arrastar();
    }
    async carregar(id) {
      if (!id || this.id === id) return;
      this.pedido = id;
      this.cv.classList.add("apv-trocando");
      sprites[id] = sprites[id] || Promise.all([carregarImg(this.url(`avatares/${id}.webp`)), carregarImg(this.url(`avatares/${id}-mask.png`))]).then(([img, mask]) => {
        const c = document.createElement("canvas"); c.width = mask.width; c.height = mask.height;
        const x = c.getContext("2d", { willReadFrequently: true }); x.drawImage(mask, 0, 0);
        const px = x.getImageData(0, 0, c.width, c.height).data;
        const reg = new Uint8Array(c.width * c.height);
        for (let i = 0, j = 0; i < px.length; i += 4, j++) {
          if (px[i + 3] < 128) continue;
          const r = px[i] > 127, g = px[i + 1] > 127, b = px[i + 2] > 127;
          reg[j] = r && !g && !b ? 2 : !r && g && !b ? 3 : !r && !g && b ? 4 : r && g && !b ? 5 : r && !g && b ? 6 : 1;
        }
        return { img, reg, sheetW: c.width };
      });
      const s = await sprites[id];
      if (this.pedido !== id) return; // outro avatar foi pedido enquanto este carregava
      Object.assign(this, s, { id });
      this.cv.classList.remove("apv-trocando");
      this.desenhar();
    }
    definir(niveis) { this.niveis = niveis || {}; this.desenhar(); }
    irPara(q) { const n = this.cfg.quadros; this.quadro = ((q % n) + n) % n; this.desenhar(); if (this.aoGirar) this.aoGirar(this.quadro); }
    girar(passo) { this.irPara(this.quadro + passo); }
    alternarPerto() { this.perto = !this.perto; this.desenhar(); return this.perto; }
    apresentar() {
      if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      const n = this.cfg.quadros; let i = 0;
      clearInterval(this._t);
      this._t = setInterval(() => { this.girar(-1); if (++i >= n) clearInterval(this._t); }, 50);
    }
    desenhar() {
      if (!this.img) return;
      const { w, h, ctx } = this, col = this.cfg.colunas;
      const sx = (this.quadro % col) * w, sy = Math.floor(this.quadro / col) * h;
      // "ver de perto": recorte do tronco ampliado
      const z = this.perto ? 1.7 : 1, cw = w / z, ch = h / z;
      const cx = (w - cw) / 2, cy = this.perto ? Math.min(h - ch, Math.max(0, h * 0.42 - ch / 2)) : 0;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, this.W, h);
      ctx.setTransform(1, 0, 0, 1, this.ox, 0);
      ctx.drawImage(this.img, sx + cx, sy + cy, cw, ch, 0, 0, w, h);
      if (SEM_MAPA) { ctx.setTransform(1, 0, 0, 1, 0, 0); this._marcadores(sx, sy, cx, cy, z); return; }
      const cores = {};
      for (const k in IDX_REGIAO) { const n = this.niveis[IDX_REGIAO[k]]; if (n != null) cores[k] = RGB[n]; }
      if (!Object.keys(cores).length) { ctx.setTransform(1, 0, 0, 1, 0, 0); return; }
      const x1 = this.of1.getContext("2d"), id = x1.createImageData(w, h), d = id.data;
      for (let y = 0; y < h; y++) {
        let j = (sy + y) * this.sheetW + sx, o = y * w * 4;
        for (let x = 0; x < w; x++, j++, o += 4) {
          const c = cores[this.reg[j]];
          if (c) { d[o] = c[0]; d[o + 1] = c[1]; d[o + 2] = c[2]; d[o + 3] = 255; }
        }
      }
      x1.putImageData(id, 0, 0);
      const x2 = this.of2.getContext("2d");
      x2.globalCompositeOperation = "source-over"; x2.clearRect(0, 0, w, h);
      x2.filter = "blur(14px)"; x2.drawImage(this.of1, 0, 0); x2.filter = "none";
      x2.globalCompositeOperation = "destination-in"; x2.drawImage(this.img, sx, sy, w, h, 0, 0, w, h);
      ctx.save(); ctx.globalCompositeOperation = "multiply"; ctx.globalAlpha = 0.78;
      ctx.drawImage(this.of2, cx, cy, cw, ch, 0, 0, w, h); ctx.restore();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      this._marcadores(sx, sy, cx, cy, z);
    }
    /** Centro (x, y) e área de cada região visível no quadro atual (cache por avatar+quadro). */
    _centros(sx, sy) {
      const k = this.id + ":" + this.quadro;
      this._cc = this._cc || {};
      if (this._cc[k]) return this._cc[k];
      const acc = {};
      for (let y = 0; y < this.h; y += 2) {
        let j = (sy + y) * this.sheetW + sx;
        for (let x = 0; x < this.w; x += 2, j += 2) {
          const r = this.reg[j]; if (r < 2) continue;
          const a = acc[r] || (acc[r] = { x: 0, y: 0, n: 0, xs: [] });
          a.x += x; a.y += y; a.n++;
        }
      }
      const out = {};
      for (const r in acc) out[IDX_REGIAO[r]] = { x: acc[r].x / acc[r].n, y: acc[r].y / acc[r].n, n: acc[r].n };
      return (this._cc[k] = out);
    }
    /** Marcadores com setinha: ponto na região + linha até uma etiqueta "Peito · Ideal" (no máximo 3). */
    _marcadores(sx, sy, cx, cy, z) {
      const regs = Object.keys(this.niveis);
      if (!regs.length || this.semMarcadores) return;
      const cen = this._centros(sx, sy), { h, ctx } = this, w = this.W, ox = this.ox;
      // peito e cintura sempre; o 3º é a região mais fora do ideal entre ombro, comprimento e manga
      const extra = ["ombro", "comprimento", "manga"].filter((r) => this.niveis[r] != null)
        .sort((a, b) => Math.abs(this.niveis[b]) - Math.abs(this.niveis[a]))[0];
      const lista = ["peito", "cintura", extra].filter((r) => r && this.niveis[r] != null && cen[r] && cen[r].n > 60);
      // letra com ~12-13 px na tela, qualquer que seja o tamanho do canvas exibido
      const esc = w / Math.max(1, this.cv.clientWidth || w);
      const fs = Math.round(Math.max(this.w * 0.03, 12.5 * esc)), padX = fs * 0.6, hBox = fs * 1.9;
      ctx.save();
      ctx.font = `600 ${fs}px Inter, system-ui, sans-serif`;
      ctx.textBaseline = "middle";
      const usados = [];
      lista.forEach((reg, i) => {
        const c = cen[reg], n = this.niveis[reg];
        let px = (c.x - cx) * z + ox, py = (c.y - cy) * z;
        if (reg === "comprimento") py = Math.min(py, h - hBox);
        const dir = i % 2 === 0 ? 1 : -1; // alterna direita/esquerda
        const comp = reg === "comprimento" || reg === "manga";
        const seta = n === 0 ? "✓" : comp ? (n < 0 ? "↑" : "↓") : (n < 0 ? "→←" : "←→");
        const txt = `${NOME_CURTO[reg]} · ${M.textoNivel(reg, n)}`;
        const tw = ctx.measureText(txt).width, sw = ctx.measureText(seta).width;
        const bw = tw + sw + padX * 3;
        let bx = dir > 0 ? w - bw - w * 0.02 : w * 0.02, by = py - hBox / 2;
        for (const u of usados) if (Math.abs(by - u) < hBox + 6) by = u + hBox + 6;
        by = Math.max(4, Math.min(h - hBox - 4, by));
        usados.push(by);
        const lx = dir > 0 ? bx : bx + bw, ly = by + hBox / 2;
        // linha
        ctx.strokeStyle = "rgba(30,30,30,.55)"; ctx.lineWidth = Math.max(1.5, w * 0.003);
        ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(px + (lx - px) * 0.35, ly); ctx.lineTo(lx, ly); ctx.stroke();
        // ponto
        ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.arc(px, py, fs * 0.55, 0, 7); ctx.fill();
        ctx.fillStyle = COR[n]; ctx.beginPath(); ctx.arc(px, py, fs * 0.36, 0, 7); ctx.fill();
        // etiqueta
        ctx.fillStyle = "rgba(255,255,255,.96)"; ctx.strokeStyle = COR[n]; ctx.lineWidth = Math.max(1.5, w * 0.004);
        ctx.beginPath(); ctx.roundRect(bx, by, bw, hBox, hBox / 2); ctx.fill(); ctx.stroke();
        ctx.fillStyle = COR[n]; ctx.fillText(seta, bx + padX, ly);
        ctx.fillStyle = "#1c1c1c"; ctx.fillText(txt, bx + padX * 2 + sw, ly);
      });
      ctx.restore();
    }
    _arrastar() {
      let x0 = null, q0 = 0;
      this.cv.addEventListener("pointerdown", (e) => { x0 = e.clientX; q0 = this.quadro; clearInterval(this._t); this.cv.setPointerCapture(e.pointerId); });
      this.cv.addEventListener("pointermove", (e) => {
        if (x0 === null) return;
        const passo = Math.max(6, this.cv.clientWidth / 40);
        const q = q0 - Math.round((e.clientX - x0) / passo);
        if (q !== this.quadro) this.irPara(q);
      });
      const fim = () => { x0 = null; };
      this.cv.addEventListener("pointerup", fim); this.cv.addEventListener("pointercancel", fim);
    }
  }

  /* ---------- janela ---------- */
  function iniciar(op) {
    const base = (op.base || ".").replace(/\/$/, "");
    // no tema os arquivos são assets soltos: op.arquivos mapeia "pasta/arquivo" -> URL do asset
    const url = (cam) => (op.arquivos && op.arquivos[cam]) || `${base}/${cam}?v=4`;
    const P = op.produto;
    const produto = {
      tipo: P.tipo || (/^camiseta|^polo/.test(P.handle) ? "malha" : "plano"),
      tamanhos: P.tamanhos, med: M.alinharGrade(M.lerTabela(P.tabela), P.tamanhos), modelagem: P.modelagem,
    };
    produto.modelagem = produto.modelagem || M.modelagemPelaTabela(produto);
    const salvo = ler();
    let lembrar = salvo ? true : true;
    let perfil = {
      altura: salvo?.altura || "", peso: salvo?.peso || "", idade: salvo?.idade || "",
      torax: num(salvo?.torax), barriga: num(salvo?.barriga), pref: num(salvo?.pref), medidas: salvo?.medidas || {},
    };
    let modelo, cfg, man, res, tamAtual, etapaAtual = 1;
    // estatística de uso (só clique, produto e tamanho — nada de altura/peso)
    const evento = (nome, extra) => { try { if (op.aoEvento) op.aoEvento(nome, Object.assign({ produto: P.handle }, extra || {})); } catch (e) { /* nunca quebra o provador */ } };

    const dlg = el("dialog", { class: "apv apv-dialog", "aria-label": "Provador virtual" });
    dlg.innerHTML = `
      <section class="apv-palco" aria-label="Manequim">
        <div class="apv-palco-topo"><span></span>
          <button type="button" class="apv-chip apv-chip-btn apv-perto" aria-pressed="false">${ICONE.lupa}Ver de perto</button></div>
        <canvas role="img" aria-label="Manequim com o caimento da peça. Arraste para girar."></canvas>
        <div class="apv-legenda" aria-hidden="true">${["-2", "-1", "0", "1", "2"].map((n) => `<div><i style="background:${COR[n]}"></i>${M.textoNivel("x", +n)}</div>`).join("")}</div>
        <div class="apv-palco-pe">
          <button type="button" class="apv-ico-btn apv-g-esq" aria-label="Girar para a esquerda">${ICONE.esq}</button>
          <label class="apv-giro"><span>Girar</span><input type="range" min="0" max="23" value="0" aria-label="Ângulo do manequim"></label>
          <button type="button" class="apv-ico-btn apv-g-dir" aria-label="Girar para a direita">${ICONE.dir}</button>
        </div>
        <div class="apv-carregando">Preparando manequim…</div>
      </section>
      <section class="apv-painel">
        <header class="apv-cab">
          ${P.foto ? `<img src="${esc(P.foto)}" alt="">` : `<span class="apv-thumb"></span>`}
          <div class="apv-cab-txt"><b>${esc(P.titulo)}</b></div>
          <button type="button" class="apv-fechar" aria-label="Fechar">${ICONE.fechar}</button>
        </header>
        <ol class="apv-passos" tabindex="-1" autofocus><li>Seu perfil</li><li>Suas medidas</li><li>Seu tamanho</li></ol>
        <div class="apv-conteudo"></div>
        <div class="apv-acoes"></div>
        <label class="apv-lembrar"><input type="checkbox" checked> <span>Guardar meu perfil neste navegador. As medidas ficam só neste aparelho e não são enviadas para a loja.</span></label>
      </section>`;
    document.body.appendChild(dlg);
    const $ = (s) => dlg.querySelector(s);
    const cv = $("canvas"), conteudo = $(".apv-conteudo"), acoes = $(".apv-acoes"), giro = $(".apv-giro input");
    $(".apv-fechar").onclick = () => dlg.close();
    $(".apv-g-esq").onclick = () => man && man.girar(1);
    $(".apv-g-dir").onclick = () => man && man.girar(-1);
    giro.oninput = () => man && man.irPara(+giro.value);
    $(".apv-perto").onclick = (e) => { if (man) e.currentTarget.setAttribute("aria-pressed", String(man.alternarPerto())); };
    const chk = $(".apv-lembrar input");
    chk.onchange = () => { lembrar = chk.checked; if (!lembrar) apagar(); };

    async function preparar() {
      [modelo, cfg] = await Promise.all([json(url("data/modelo.json")), json(url("data/avatares.json"))]);
      giro.max = cfg.quadros - 1;
      man = new Manequim(cv, cfg, url, (q) => { giro.value = q; });
      await atualizarManequim(true);
      $(".apv-carregando").remove();
    }

    const perfilValido = () => perfil.altura >= 140 && perfil.altura <= 210 && perfil.peso >= 40 && perfil.peso <= 180;
    async function atualizarManequim(apresentar) {
      if (!man) return;
      let id;
      if (perfilValido()) {
        const corpo = M.medirCorpo(modelo, perfil);
        id = M.avatarPorMedidas(cfg.avatares, corpo);
      } else id = Object.keys(cfg.avatares).find((k) => k === "imc24-normal") || Object.keys(cfg.avatares)[0];
      await man.carregar(id);
      if (apresentar) man.apresentar();
    }
    let tAtualiza;
    const agendarManequim = () => { clearTimeout(tAtualiza); tAtualiza = setTimeout(() => atualizarManequim(false), 350); };

    function passos(n) {
      etapaAtual = n;
      dlg.querySelectorAll(".apv-passos li").forEach((li, i) => { li.className = i + 1 === n ? "on" : i + 1 < n ? "ok" : ""; li.toggleAttribute("aria-current", i + 1 === n); });
      $(".apv-lembrar").style.display = n === 3 ? "none" : "";
      $(".apv-legenda").classList.toggle("on", n === 3 && !SEM_MAPA);
      if (n !== 3 && man) man.definir({});
    }
    function mostrar(html) { const e = el("div", { class: "apv-etapa" }, html); conteudo.innerHTML = ""; conteudo.appendChild(e); conteudo.scrollTop = 0; return e; }

    /** Silhueta do botão k (1..5): tronco de frente (peito/ombros) ou perfil de lado (abdômen). */
    function silhueta(chave, k) {
      const f = (n) => n.toFixed(2);
      let d;
      if (chave === "barriga") {
        // de frente: ombros iguais, a lateral da cintura vai abrindo
        const b = 3.6 + k * 1.15;
        d = `<circle cx="12" cy="3.2" r="2.1"/><path d="M5.6 8 Q12 5.8 18.4 8 Q${f(12 + b + 1.6)} 15 ${f(12 + 3.4 + k * 0.35)} 21.5 M5.6 8 Q${f(12 - b - 1.6)} 15 ${f(12 - 3.4 - k * 0.35)} 21.5"/>`;
      } else {
        const s = 4.6 + k * 0.85, w = 3.4 + k * 0.6; // meia largura do ombro e da cintura
        d = `<circle cx="12" cy="3.2" r="2.1"/><path d="M${f(12 - s)} 8 Q12 5.8 ${f(12 + s)} 8 L${f(12 + w)} 21.5 M${f(12 - s)} 8 L${f(12 - w)} 21.5"/>`;
      }
      return `<svg viewBox="0 0 24 23" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
    }

    function escala(chave, titulo, rotulos, nomes) {
      const box = el("div", { class: "apv-escala" }, `<div class="apv-escala-top"><b id="apv-${chave}-t">${titulo}</b><span hidden></span></div>
        <div class="apv-escala-pontos" role="radiogroup" aria-labelledby="apv-${chave}-t"></div>
`);
      const pts = box.querySelector(".apv-escala-pontos"), lab = box.querySelector(".apv-escala-top span");
      const marcar = () => pts.querySelectorAll("button").forEach((b, i) => { b.setAttribute("aria-checked", String(i + 1 === perfil[chave])); b.tabIndex = i + 1 === perfil[chave] ? 0 : -1; });
      for (let i = 1; i <= 5; i++) {
        const b = el("button", { type: "button", role: "radio", class: "apv-txt" }, esc(nomes[i - 1]));
        b.onclick = () => { perfil[chave] = i; lab.textContent = nomes[i - 1]; marcar(); if (chave !== "pref") { perfil.medidas = {}; agendarManequim(); } };
        b.onkeydown = (e) => {
          const d = e.key === "ArrowRight" || e.key === "ArrowUp" ? 1 : e.key === "ArrowLeft" || e.key === "ArrowDown" ? -1 : 0;
          if (!d) return; e.preventDefault();
          const v = Math.min(5, Math.max(1, perfil[chave] + d)); pts.children[v - 1].click(); pts.children[v - 1].focus();
        };
        pts.appendChild(b);
      }
      marcar();
      return box;
    }

    /* etapa 1 — perfil */
    function etapa1() {
      passos(1);
      const e = mostrar(`<h2>Seu perfil</h2>
        <div class="apv-numeros">
          <div class="apv-num"><label for="apv-alt">Altura</label><div><input id="apv-alt" type="number" inputmode="numeric" min="140" max="210" placeholder="175" value="${esc(perfil.altura)}"><small>cm</small></div></div>
          <div class="apv-num"><label for="apv-peso">Peso</label><div><input id="apv-peso" type="number" inputmode="numeric" min="40" max="180" placeholder="78" value="${esc(perfil.peso)}"><small>kg</small></div></div>
          <div class="apv-num"><label for="apv-idade">Idade</label><div><input id="apv-idade" type="number" inputmode="numeric" min="14" max="99" placeholder="30" value="${esc(perfil.idade)}"><small>anos</small></div></div>
        </div><div class="apv-erro" role="alert"></div>
        <p class="apv-secao">Formato do corpo</p>`);
      e.appendChild(escala("torax", "Peito e ombros", ["Estreitos", "Largos"], ["Bem estreitos", "Estreitos", "Médios", "Largos", "Bem largos"]));
      e.appendChild(escala("barriga", "Abdômen", ["Reto", "Volumoso"], ["Bem reto", "Reto", "Médio", "Saliente", "Volumoso"]));
      const [ia, ip, ii] = e.querySelectorAll("input");
      e.querySelectorAll(".apv-num").forEach((n) => n.addEventListener("click", () => n.querySelector("input").focus()));
      const erro = e.querySelector(".apv-erro");
      const sync = () => { perfil.altura = +ia.value || ""; perfil.peso = +ip.value || ""; perfil.idade = +ii.value || ""; perfil.medidas = {}; erro.textContent = ""; agendarManequim(); };
      [ia, ip, ii].forEach((x) => (x.oninput = sync));
      acoes.innerHTML = "";
      const ir = el("button", { class: "apv-btn", type: "button" }, "Continuar");
      ir.onclick = () => {
        sync();
        if (!(perfil.altura >= 140 && perfil.altura <= 210)) return (erro.textContent = "Informe sua altura em centímetros (ex.: 175)."), ia.focus();
        if (!(perfil.peso >= 40 && perfil.peso <= 180)) return (erro.textContent = "Informe seu peso em quilos (ex.: 78)."), ip.focus();
        if (!(perfil.idade >= 14 && perfil.idade <= 99)) return (erro.textContent = "Informe sua idade."), ii.focus();
        etapa2();
      };
      e.addEventListener("keydown", (ev) => { if (ev.key === "Enter" && ev.target.tagName === "INPUT") ir.click(); });
      acoes.appendChild(ir);
      if (!perfil.altura) setTimeout(() => ia.focus(), 50);
    }

    /* etapa 2 — medidas ajustáveis */
    function etapa2() {
      passos(2);
      const est = M.medirCorpo(modelo, Object.assign({}, perfil, { medidas: {} }));
      const e = mostrar(`<h2>Suas medidas</h2><p class="apv-sub">Estimamos estas medidas pela sua altura e peso. Se você souber suas medidas reais, ajuste os valores.</p>`);
      const linha = (chave, nome, icone) => {
        const base0 = Math.round(est[chave]);
        const val = () => Math.round(perfil.medidas[chave] || base0);
        const box = el("div", { class: "apv-medida" }, `<div class="apv-medida-top"><span class="apv-medida-ico">${icone}</span>
          <div class="apv-medida-nome"><b id="apv-m-${chave}">${nome}</b><span></span></div><div class="apv-medida-val"></div></div>
          <div class="apv-medida-ctrl"><button type="button" class="apv-ico-btn" aria-label="Diminuir ${nome.toLowerCase()}">${ICONE.menos}</button>
          <input type="range" min="${base0 - 18}" max="${base0 + 18}" step="1" value="${val()}" aria-labelledby="apv-m-${chave}">
          <button type="button" class="apv-ico-btn" aria-label="Aumentar ${nome.toLowerCase()}">${ICONE.mais}</button></div>`);
        const r = box.querySelector("input"), st = box.querySelector(".apv-medida-nome span"), v = box.querySelector(".apv-medida-val");
        const pintar = () => {
          const aj = perfil.medidas[chave] && Math.round(perfil.medidas[chave]) !== base0;
          st.textContent = aj ? "Ajustado por você" : "Estimado"; st.className = aj ? "aj" : "";
          v.innerHTML = `${val()}<small>cm</small>`; r.value = val(); r.setAttribute("aria-valuetext", val() + " centímetros");
        };
        const set = (x) => { perfil.medidas[chave] = Math.min(+r.max, Math.max(+r.min, x)); pintar(); agendarManequim(); };
        r.oninput = () => set(+r.value);
        const [bm, bp] = box.querySelectorAll("button");
        bm.onclick = () => set(val() - 1); bp.onclick = () => set(val() + 1);
        pintar();
        return box;
      };
      e.appendChild(linha("peito", "Tórax", ICONE.peito));
      e.appendChild(linha("cintura", "Cintura", ICONE.cintura));
      e.appendChild(el("details", { class: "apv-ajuda" }, `<summary>Como medir</summary>
        <p><b>Tórax:</b> passe a fita na parte mais larga do peito, por baixo dos braços, sem apertar.</p>
        <p><b>Cintura:</b> passe a fita na altura do umbigo, relaxado, sem encolher a barriga.</p>`));
      const sep = el("div", { style: "height:22px" }); e.appendChild(sep);
      e.appendChild(escala("pref", "Como você gosta de vestir?", ["Mais justo", "Mais solto"], ["Bem justo", "Justo", "Na medida", "Solto", "Bem solto"]));
      acoes.innerHTML = "";
      const v = el("button", { class: "apv-btn sec", type: "button", "aria-label": "Voltar" }, ICONE.voltar);
      v.onclick = etapa1;
      const ir = el("button", { class: "apv-btn", type: "button" }, "Encontrar meu tamanho");
      ir.onclick = () => { if (lembrar) gravar(perfil); etapa3(); };
      acoes.append(v, ir);
    }

    /* etapa 3 — resultado */
    function etapa3() {
      passos(3);
      res = M.recomendar(modelo, perfil, produto);
      evento("provador_resultado", { tamanho: res.melhor, confianca: res.confianca });
      tamAtual = res.melhor;
      atualizarManequim(false);
      pintarResultado(true);
    }
    const niveis = (t) => Object.fromEntries(Object.entries(res.porTamanho[t].regioes).map(([k, v]) => [k, v.nivel]));
    function pintarResultado(primeira) {
      const r = res, t = tamAtual;
      const conf = { alta: [3, "Alta confiança"], boa: [2, "Boa confiança"], media: [1, "Entre dois tamanhos"], baixa: [1, "Fora da grade"] }[r.confianca];
      let aviso = "";
      if (r.foraDaGrade) aviso = `<p class="apv-aviso">Pelas suas medidas, até o ${r.melhor} pode ficar justo nesta peça.</p>`;
      else if (r.alternativa) aviso = `<p class="apv-aviso">Você está entre o <b>${r.melhor}</b> e o <b>${r.alternativa}</b>. O ${r.melhor} veste melhor no conjunto; toque no ${r.alternativa} para comparar.</p>`;
      const e = mostrar(`<div class="apv-res-topo"><div class="apv-res-tam" aria-hidden="true">${esc(r.melhor)}</div>
          <div><h2>Seu tamanho é ${esc(r.melhor)}</h2><span class="apv-confianca"><i>${[1, 2, 3].map((k) => `<b class="${k <= conf[0] ? "on" : ""}"></b>`).join("")}</i>${conf[1]}</span></div></div>
        ${aviso}
        <div class="apv-tams" role="group" aria-label="Comparar tamanhos"></div>
        <p class="apv-dica">Toque em outro tamanho para ver como ele veste no manequim.</p>
        <ul class="apv-fitas"></ul>`);
      if (!primeira) e.style.animation = "none";
      const box = e.querySelector(".apv-tams");
      for (const s of r.tamanhos) {
        const b = el("button", { type: "button", "aria-pressed": String(s === t) }, esc(s) + (s === r.melhor ? `<span class="rec">Ideal</span>` : ""));
        b.onclick = () => { tamAtual = s; pintarResultado(false); };
        box.appendChild(b);
      }
      const ul = e.querySelector(".apv-fitas"), regs = r.porTamanho[t].regioes;
      for (const reg of M.REGIOES) {
        const v = regs[reg]; if (!v) continue;
        const ext = reg === "comprimento" || reg === "manga" ? ["Curto", "Longo"] : ["Justo", "Folgado"];
        ul.appendChild(el("li", { class: "apv-fita" }, `<div class="apv-fita-top"><b>${M.NOME_REGIAO[reg]}</b><span><i style="background:${COR[v.nivel]}"></i>${M.textoNivel(reg, v.nivel)}</span></div>
          <div class="apv-regua" role="img" aria-label="${M.NOME_REGIAO[reg]}: ${M.textoNivel(reg, v.nivel)}"><div class="apv-regua-faixa"></div><div class="apv-regua-ideal"></div><div class="apv-regua-ticks"></div><div class="apv-regua-marca" style="left:${(v.pos * 100).toFixed(1)}%"></div></div>
          <div class="apv-regua-rot"><span>${ext[0]}</span><span>Ideal</span><span>${ext[1]}</span></div>`));
      }
      if (man) man.definir(niveis(t));
      acoes.innerHTML = "";
      const rf = el("button", { class: "apv-btn sec", type: "button", "aria-label": "Refazer" }, ICONE.refazer);
      rf.onclick = etapa1;
      const ok = el("button", { class: "apv-btn", type: "button" }, `${ICONE.sacola}Adicionar à sacola · ${esc(t)}`);
      ok.querySelector("svg").style.cssText = "width:18px;height:18px";
      ok.onclick = () => { evento("provador_adicionou", { tamanho: t, recomendado: r.melhor }); if (op.aoEscolher) op.aoEscolher(t, { adicionar: true }); dlg.close(); };
      acoes.append(rf, ok);
    }

    return {
      async abrir() {
        evento("provador_aberto");
        if (!dlg.open) dlg.showModal();
        if (!man) {
          try { await preparar(); } catch (err) { $(".apv-carregando").textContent = "Não foi possível carregar o manequim."; }
        }
        if (perfilValido() && perfil.idade && salvo) etapa3(); else etapa1();
      },
    };
  }

  window.AnkorProvador = { iniciar, ICONE };
})();
